import { render, staticRenderFns } from "./SetHeader.vue?vue&type=template&id=58b83ba5&"
import script from "./SetHeader.vue?vue&type=script&lang=js&"
export * from "./SetHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports